import { Routes } from '@angular/router';
import { MainLayout } from './layouts/main-layout/main-layout';
import { Dashboard } from './pages/dashboard/dashboard';
import { Company } from './pages/company/company';
import { Store } from './pages/store/store';
import { Customer } from './pages/customer/customer';
import { Template } from './pages/template/template';
import { Schedule } from './pages/schedule/schedule';

export const routes: Routes = [
    {
        path: '',
        component: MainLayout,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            { path: 'dashboard', component: Dashboard },
            { path: 'company', loadComponent: () => import('./pages/company/company').then(m => m.Company) },
            { path: 'store', loadComponent: () => import('./pages/store/store').then(m => m.Store) },
            { path: 'customer', loadComponent: () => import('./pages/customer/customer').then(m => m.Customer) },
            { path: 'template', loadComponent: () => import('./pages/template/template').then(m => m.Template) },
            { path: 'schedule', loadComponent: () => import('./pages/schedule/schedule').then(m => m.Schedule) },
            { path: 'whatsapp-sent', loadComponent: () => import('./pages/whatsapp-sent/whatsapp-sent').then(m => m.WhatsAppSent) }
        ]
    }
];
